import React from 'react';
import { arrayOf, node, object, oneOfType, shape, string } from 'prop-types';
import { flatMap } from 'lodash';
import classNames from 'classnames';

import NamedLink from '../NamedLink/NamedLink';
import ExternalLink from '../ExternalLink/ExternalLink';

import css from './Breadcrumbs.module.css';

const renderLink = linkItem => {
  const { key, href, label, name, to, active } = linkItem;

  const isNamedLink = !!name;
  const isExternalLink = !!href;

  const LinkWrapper = ({ children }) =>
    isNamedLink ? (
      <NamedLink
        name={name}
        to={to}
        className={classNames(css.breadcrumbLink, { [css.breadcrumbLinkActive]: active })}
      >
        {children}
      </NamedLink>
    ) : isExternalLink ? (
      <ExternalLink href={href} className={css.breadcrumbLink}>
        {children}
      </ExternalLink>
    ) : (
      <span className={css.breadcrumbLinkActive}>{children}</span>
    );

  return <LinkWrapper key={key ?? href ?? name}>{label}</LinkWrapper>;
};

const renderSeparator = index => (
  <span key={`separator.${index}`} className={css.separator}>
    {' '}
    /{' '}
  </span>
);

const Breadcrumbs = props => {
  const { links, className } = props;

  const linksWithSeparators = flatMap(links, (value, index, array) =>
    array.length - 1 !== index ? [value, { separator: true }] : value
  );

  return (
    <span className={classNames(css.root, className)}>
      {linksWithSeparators.map(({ separator, ...linkProps }, index) =>
        separator ? renderSeparator(index) : renderLink(linkProps)
      )}
    </span>
  );
};

Breadcrumbs.propTypes = {
  links: arrayOf(
    shape({
      key: string,
      href: string,
      name: string,
      to: shape({
        search: string,
      }),
      label: oneOfType([string, object]).isRequired,
    })
  ),
};

export default Breadcrumbs;
